import axios from 'axios';
import store from './store';

axios.defaults.baseURL = '/api/';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const csrfToken = document.head.querySelector('meta[name="csrf-token"]');

if (csrfToken) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken.content;
}
else {
    // See https://laravel.com/docs/csrf#csrf-x-csrf-token
}

axios.interceptors.response.use(response => Promise.resolve(response), (error) => {
    // Auto log out if response is 401
    if (error.response) {
        if (error.response.status === 401) {
            store.dispatch('user/logout');
        }
    }
    return Promise.reject(error);
});

export default {
    clearToken() {
        delete axios.defaults.headers.common.Authorization;
    },
    delete(url, data, config) {
        return axios.post(url, { ...data, _method: 'DELETE' }, config);
    },
    get(url, config) {
        return axios.get(url, config);
    },
    patch(url, data, config) {
        return axios.patch(url, { ...data, _method: 'PATCH' }, config);
    },
    post(url, data, config) {
        return axios.post(url, data, config);
    },
    setToken(accessToken) {
        axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    }
};
